import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { Snowflake, ShieldCheck } from "lucide-react";

export function FreezeWallet() {
  const [f, setF] = useState(null);
  useEffect(() => { api.getFreezes().then(setF).catch(() => {}); }, []);
  if (!f) return null;

  const max = f.max || 3;

  return (
    <div className="rounded-3xl bg-card border border-border p-5 space-y-4" data-testid="freeze-wallet">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-display text-lg font-medium tracking-tight flex items-center gap-2">
            <Snowflake className="w-5 h-5" style={{ color: "#3B9BD6" }} /> Streak Freezes
          </h2>
          <p className="text-xs text-muted-foreground">One freeze protects a single missed day.</p>
        </div>
        <span className="text-sm font-display font-medium tabular-nums" data-testid="freeze-available">
          {f.available}/{max}
        </span>
      </div>

      {/* freeze slots */}
      <div className="flex gap-2">
        {Array.from({ length: max }).map((_, i) => {
          const filled = i < f.available;
          return (
            <motion.div
              key={i}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: i * 0.06 }}
              className="flex-1 h-16 rounded-2xl flex items-center justify-center border"
              style={{
                background: filled ? "rgba(59,155,214,0.1)" : "hsl(var(--muted))",
                borderColor: filled ? "rgba(59,155,214,0.35)" : "transparent",
              }}
            >
              <Snowflake className="w-6 h-6" style={{ color: filled ? "#3B9BD6" : "hsl(var(--muted-foreground))", opacity: filled ? 1 : 0.35 }} />
            </motion.div>
          );
        })}
      </div>
      <p className="text-xs text-muted-foreground">Earn a freeze every 7-day streak (up to {max} banked).</p>

      {/* saved days */}
      <div className="pt-1 border-t border-border">
        <div className="text-xs font-semibold text-foreground/70 mt-3 mb-2">Days a freeze saved</div>
        {f.saved_dates && f.saved_dates.length > 0 ? (
          <div className="space-y-1.5">
            {f.saved_dates.map((d) => (
              <div key={d} className="flex items-center gap-2.5 text-sm" data-testid="freeze-saved-day">
                <div className="w-7 h-7 rounded-lg bg-[#3B9BD6]/10 flex items-center justify-center">
                  <ShieldCheck className="w-4 h-4" style={{ color: "#3B9BD6" }} />
                </div>
                <span className="text-foreground/80">
                  {new Date(d + "T00:00:00").toLocaleDateString("en", { weekday: "long", month: "short", day: "numeric" })}
                </span>
                <span className="ml-auto text-xs text-muted-foreground">streak protected</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground py-1">No freezes used yet — keep your streak alive! ❄️</p>
        )}
      </div>
    </div>
  );
}
